module.exports = __webpack_public_path__ + "img/contact-us-icon.300e2013.svg";